import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';

const PublicRegisterModalContent = (props) => {

  const extraWristbandCost = 175;
  const numRegularWristbands = 6;
  const priceIncreaseDate = 1686805200000;

  const [boatName, setBoatName] = useState("");
  const [teamEmail, setTeamEmail] = useState("");
  const [teamPhoneNumber, setTeamPhoneNumber] = useState("");
  const [boatMake, setBoatMake] = useState("");
  const [boatLength, setBoatLength] = useState();
  const [ownerFirstName, setOwnerFirstName] = useState("");
  const [ownerLastName, setOwnerLastName] = useState("");
  const [ownerGender, setOwnerGender] = useState("Male");
  const [ownerDivision, setOwnerDivision] = useState("Adult");
  const [captainFirstName, setCaptainFirstName] = useState("");
  const [captainLastName, setCaptainLastName] = useState("");
  const [captainGender, setCaptainGender] = useState("Male");
  const [captainDivision, setCaptainDivision] = useState("Adult");
  const [mateFirstName, setMateFirstName] = useState("");
  const [mateLastName, setMateLastName] = useState("");
  const [mateGender, setMateGender] = useState("Male");
  const [mateDivision, setMateDivision] = useState("Adult");
  const [newPassengerFirstName, setNewPassengerFirstName] = useState("");
  const [newPassengerLastName, setNewPassengerLastName] = useState("");
  const [newPassengerGender, setNewPassengerGender] = useState("Male");
  const [newPassengerDivision, setNewPassengerDivision] = useState("Adult");
  const [anglerDict, setAnglerDict] = useState({});
  const [registeredAnglerList, setRegisteredAnglerList] = useState([]);    // FIXME: from tournament registered angler db
  const [agreeIsChecked, setAgreeIsChecked] = useState(false);
  const [isEarlyBirdPricing, setIsEarlyBirdPricing] = useState(false);  
  const [numExtraWristbands, setNumExtraWristbands] = useState(0);
  const [registrationFee, setRegistrationFee] = useState();

  const calculateTotalWristbands = () => {
    return numRegularWristbands + parseInt(numExtraWristbands);
  }

  const calculateTotalFee = () => {
    return registrationFee + (extraWristbandCost * numExtraWristbands);
  }

  const calculateRegistrationFee = () => {
    const isBeforeDeadline = Date.now() < priceIncreaseDate;
    setIsEarlyBirdPricing(isBeforeDeadline);
    if (isBeforeDeadline) {
      setRegistrationFee(2500);
    } else {
      setRegistrationFee(3000);
    }
  }

  const checkboxHandler = () => {
    setAgreeIsChecked(!agreeIsChecked);
  }
  
  const phoneFormat = (userInput) => {
    var input = userInput.replace(/\D/g,'').substring(0,10); //Strip everything but 1st 10 digits
    var size = input.length;
    if (size>0) {input="("+input}
    if (size>3) {input=input.slice(0,4)+") "+input.slice(4)}
    if (size>6) {input=input.slice(0,9)+"-" +input.slice(9)}
    return input;
  }

  const validateAndSubmitUserInput = () => {

    // if (!boatName) { 
    //   toast.error("Please enter a value for the boat name field.");
    //   return;
    // };

    // if (!teamEmail.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ) {
    //   toast.error("Please enter a valid email address."); 
    //   return;
    // };

    // if (!teamPhoneNumber.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im) ) { 
    //   toast.error("Please enter a valid phone number.");
    //   return;
    // };

    // if (!/^[0-9]+$/.test(boatLength)) { 
    //   toast.error("Boat length must be a number.");
    //   return;
    // };

    // if (Object.keys(anglerDict).length < 1) {
    //   toast.error("At least one angler must be on the boat.");
    //   return;
    // };

    // if (!ownerFirstName || !ownerLastName) {
    //   toast.error("No owner has been added yet.");
    //   return;
    // };

    // if (!captainFirstName || !captainLastName) {
    //   toast.error("No captain has been added yet.");
    //   return;
    // };

    // if (!mateFirstName || !mateLastName) {
    //   toast.error("No mate has been added yet.");
    //   return;
    // };

    // Creat boat record
    let boatOptions = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/boat',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        name: boatName,
        email: teamEmail,
        phoneNumber: teamPhoneNumber,
        make: boatMake,
        length: boatLength,
      })
    }
    axios(boatOptions);

    // Create angler records
    // Object.keys(anglerDict).forEach(key => {

    //   let parsedNameArray = key.split(" ");    // parse angler name
    //   let firstName = parsedNameArray[0];
    //   let lastName = parsedNameArray[1];

    //   let isOwner = false;    // identify role on boat
    //   let isCaptain = false;
    //   let isMate = false;
    //   let isAngler = true;
    //   console.log(anglerDict[key]);
    //   if (anglerDict[key] === "owner") {
    //     isOwner = true;
    //   } else if (anglerDict[key] === "captain") {
    //     isCaptain = true;
    //   } else if (anglerDict[key] === "mate") {
    //     isMate = true;
    //   }

    //   let anglerOptions = {
    //     method: 'POST',
    //     url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/angler',
    //     headers: {'Content-Type': 'application/json'},
    //     data: JSON.stringify({
    //       firstName: firstName,
    //       lastName: lastName,
    //       boatName: boatName,
    //       owner: isOwner,
    //       captain: isCaptain,
    //       mate: isMate,
    //       angler: isAngler,
    //     })
    //   }

    //   axios(anglerOptions);    // make http request

    // })
    
    // axios.post('https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server')    // FIXME
    // .then(res => {
    //   console.log(res.data)
    // }).catch(err => {
    //   console.log(err)
    // })

  }

  const addAnglerToBoat = (firstName, lastName, type) => {

    const fullName = firstName + " " + lastName;

    if (!firstName) { 
      toast.warning("Missing  " + type + " first name.");
      return false;
    };

    if (!lastName) { 
      toast.warning("Missing  " + type + " last name.");
      return false;
    };

    if (Object.keys(anglerDict).includes(fullName)) {
      toast.warning("The name " + fullName + " already exists.");
      return false;
    }

    if ( Object.values(anglerDict).includes(type) && type !== "passenger" ) {
      toast.warning("This boat already has a " + type + ". You may delete and replace them if needed.");
      return false;
    }

    let newPair = {};
    newPair[fullName] = type;
    setAnglerDict(anglerDict => ({...anglerDict, ...newPair}));

    if (type === "passenger") {
      setNewPassengerFirstName("");
      setNewPassengerLastName("");
    }
  }

  const removeAnglerFromBoat = (fullName) => {
    const newAnglerDict = {...anglerDict};
    delete newAnglerDict[fullName];
    setAnglerDict(newAnglerDict);
  }

  useEffect(
    () => {
      calculateRegistrationFee();
  }, []);
  
  return (
    <>
      <div className="modal">
        <div onClick={props.toggleModal} className="overlay"></div>
        <div className="modal-content">
          <h2>Register New Team</h2>
          <label>*Boat Name: </label><input required type="text" value={boatName} onChange={(e) => setBoatName(e.target.value)}></input><br/><br/>
          <label>*Team Email: </label><input required type="email" value={teamEmail} onChange={(e) => setTeamEmail(e.target.value)}></input><br/><br/>
          <label>*Team Phone Number: </label><input required type="tel" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" value={teamPhoneNumber} onChange={(e) => setTeamPhoneNumber(phoneFormat(e.target.value))}></input><br/><br/>
          <label>Boat Make: </label><input type="text" value={boatMake} onChange={(e) => setBoatMake(e.target.value)} ></input><br/><br/>
          <label>Boat Length (ft): </label><input type="number" min="1" step="1" value={boatLength} onChange={(e) => setBoatLength(e.target.value)} ></input><br/><br/>
          <label>Owner: </label>
            <input placeholder="First name" type="text" value={ownerFirstName} onChange={(e) => setOwnerFirstName(e.target.value)}></input>
            <input placeholder="Last name" type="text" value={ownerLastName} onChange={(e) => setOwnerLastName(e.target.value)}></input>
            <label>Gender: </label>
            <select value={ownerGender} onChange={(e) => setOwnerGender(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>
            <label>Division: </label>
            <select value={ownerDivision} onChange={(e) => setOwnerDivision(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Adult">Adult</option>
                <option value="Junior">Junior</option>
            </select>
            <button className="btn-modal-end" onClick={() => {addAnglerToBoat(ownerFirstName, ownerLastName, "owner")}}>Add to Angler List</button><br/><br/>
          <label>Captain: </label>
            <input placeholder="First name" type="text" value={captainFirstName} onChange={(e) => setCaptainFirstName(e.target.value)}></input> 
            <input placeholder="Last name" type="text" value={captainLastName} onChange={(e) => setCaptainLastName(e.target.value)}></input>
            <label>Gender: </label>
            <select value={captainGender} onChange={(e) => setCaptainGender(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>
            <label>Division: </label>
            <select value={captainDivision} onChange={(e) => setCaptainDivision(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Adult">Adult</option>
                <option value="Junior">Junior</option>
            </select>
            <button className="btn-modal-end" onClick={() => {addAnglerToBoat(captainFirstName, captainLastName, "captain")}}>Add to Angler List</button><br/><br/>
          <label>Mate: </label>
            <input placeholder="First name" type="text" value={mateFirstName} onChange={(e) => setMateFirstName(e.target.value)}></input> 
            <input placeholder="Last name" type="text" value={mateLastName} onChange={(e) => setMateLastName(e.target.value)}></input>
            <label>Gender: </label>
            <select value={mateGender} onChange={(e) => setMateGender(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>
            <label>Division: </label>
            <select value={mateDivision} onChange={(e) => setMateDivision(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Adult">Adult</option>
                <option value="Junior">Junior</option>
            </select>
            <button className="btn-modal-end" onClick={() => {addAnglerToBoat(mateFirstName, mateLastName, "mate")}}>Add to Angler List</button><br/><br/>
          <br/>
          <label><strong><u>Anglers on this Boat (at least 1 required):</u></strong></label><br/>
          { (Object.keys(anglerDict).length > 0) ? (
            <>
              <p>** must add the owner, captain, and mate if they are anglers too **</p>

              {Object.keys(anglerDict).map((angler) => {
                return <><label>{angler} ({anglerDict[angler]}) </label><button className="btn-modal-end" onClick={() => {removeAnglerFromBoat(angler)}} >X</button><br/><br/></>
              })}
            </>
          ) : (
            <p>** no anglers added yet **</p>
          )}
          <input placeholder="First name" type="text" value={newPassengerFirstName} onChange={(e) => setNewPassengerFirstName(e.target.value)}></input> 
          <input placeholder="Last name" type="text" value={newPassengerLastName} onChange={(e) => setNewPassengerLastName(e.target.value)}></input>
          <label>Gender: </label>
            <select value={newPassengerGender} onChange={(e) => setNewPassengerGender(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>
            <label>Division: </label>
            <select value={newPassengerDivision} onChange={(e) => setNewPassengerDivision(e.target.value)}>
              <option value="" disabled selected hidden></option>
                <option value="Adult">Adult</option>
                <option value="Junior">Junior</option>
            </select>
          <button className="btn-modal-end" onClick={() => {addAnglerToBoat(newPassengerFirstName, newPassengerLastName, "passenger")}}>Add to Angler List</button><br/><br/>
          <br/>
          <label><strong><u>Pricing</u></strong></label><br/>
          <label>Boat Registration Fee ({ isEarlyBirdPricing ? <span>Early Bird Pricing</span> : <span>Normal Pricing</span>}) = <strong>${registrationFee}</strong></label><br/>
          <label>Wristbands (6ct included free with registration) = <strong>$0</strong></label><br/>
          <label>Extra Wristbands (</label><input type="number" min="0" max="12" step="1" value={numExtraWristbands} onChange={(e) => setNumExtraWristbands(e.target.value)} ></input><label>ct., 12 max.) = <strong>${numExtraWristbands * 175}</strong></label><br/><br/>
          <label>Your Total Wristbands (18 max.)= <strong>{calculateTotalWristbands()}</strong></label><br/>
          <label>Your Total Cost = <strong>${calculateTotalFee()}</strong></label><br/><br/>
          <input type="checkbox" onChange={checkboxHandler} /> I confirm that everyone has read and understood <a target="_blank" href="https://www.billfishpachanga.com/rules/">  the rules.</a><br/><br/>
          <br/>
          <button className="btn-modal" disabled={!agreeIsChecked} onClick={validateAndSubmitUserInput} type="button">Go to Payment</button>
          <button className="close-modal" onClick={props.toggleModal}>CLOSE</button>
        </div>
      </div>
    </>
  );
}

export default PublicRegisterModalContent;

